import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Button, Container, Link } from '@mui/material';
import { useRouter } from 'next/router';
import { useState } from 'react';

import CustomButton from '../ui/CustomButton';

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const EmploymentSubMenu = () => {
  const router = useRouter();
  const [selectedSubMenu, setSelectedSubMenu] = useState('');

  function getActiveClassName(currentPath: string[]) {
    const pathName = router.pathname;
    if (pathName === '/' && currentPath.includes('/')) {
      return 'Mui-second-level-selected-menu';
    }
    const matchingPaths = currentPath.filter((p) => pathName.startsWith(p));
    if (matchingPaths.length > 0 && !currentPath.includes('/'))
      return 'Mui-second-level-selected-menu';
    return '';
  }

  // handle click for Sub Menu in Mobile view
  function getSubMenuHoverClassName(currentSubMenu: string) {
    if (
      currentSubMenu !== undefined &&
      currentSubMenu !== '' &&
      selectedSubMenu !== undefined &&
      selectedSubMenu !== '' &&
      selectedSubMenu === currentSubMenu
    ) {
      return 'dropdown-menu button-hover';
    }
    return 'dropdown-menu';
  }

  function toggleSelectedSubMenu(currentSubMenu: string) {
    if (selectedSubMenu !== undefined && selectedSubMenu !== '') {
      if (currentSubMenu !== selectedSubMenu) {
        setSelectedSubMenu(currentSubMenu);
      } else {
        setSelectedSubMenu('');
      }
    } else {
      setSelectedSubMenu(currentSubMenu);
    }
  }

  return (
    <Box
      sx={{
        backgroundColor: 'rgba(235, 235, 235, 0.85)',
        backdropFilter: 'saturate(50%) blur(5px)',
        borderBottom: '1px solid #dcdcdc',
        py: 1,
        px: 3,
        color: '#14181f',
        textAlign: 'right',
        position: 'sticky',
        left: 0,
        right: 0,
        top: 64,
        zIndex: 999,
        minHeight: { sm: 50, md: 54 },
        display: { xs: 'none', sm: 'flex' },
        justifyContent: 'flex-end',
        '& a:hover': { backgroundColor: 'transparent' },
      }}
      component="nav"
      aria-label="Secondary Navigation"
    >
      <Container
        maxWidth="lg"
        sx={{
          p: '0 !important',
          display: 'flex',
          '& .Mui-second-level-selected-menu::before': { bottom: -10 },
        }}
      >
        <CustomButton
          href="/employment-tax/"
          text="Employment Tax<br />Forms"
          custom="margin-right:0px; line-height:1.2; padding-top:0px; padding-bottom:0px; text-align:left;"
          icon={
            <Box
              component="img"
              src="/assets/images/employment-icon.png"
              alt="Employment Tax Forms"
              sx={{ width: { sm: 32, md: 36 }, height: { sm: 32, md: 36 } }}
            />
          }
          // className={getActiveClassName(['/employment-tax'])}
          sm="12px"
          md="14px"
        />
        <Box sx={{ flexGrow: 1 }} />
        <Box
          className={getSubMenuHoverClassName('btn-employment-supported-forms')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-employment-supported-forms"
            onClick={() =>
              toggleSelectedSubMenu('btn-employment-supported-forms')
            }
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
            className={getActiveClassName([
              '/employment-tax/e-file-irs-form-941',
              '/employment-tax/efile-irs-form-941-x-online',
              '/employment-tax/e-file-irs-form-940',
              '/employment-tax/efile-irs-form-940-amendment',
              '/employment-tax/e-file-irs-form-94x-pin-request',
              '/employment-tax/e-file-irs-form-941-schedule-r',
              '/employment-tax/e-file-irs-form-943',
              '/employment-tax/e-file-irs-form-944',
              '/employment-tax/e-file-irs-form-945',
              '/employment-tax/e-file-irs-form-943-x',
              '/employment-tax/e-file-irs-form-945-x',
            ])}
          >
            Supported Forms
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{ width: 200, '&:before': { left: 50 } }}
          >
            <Box component="ul">
              <li>
                <Link href="/employment-tax/e-file-irs-form-941/">
                  Form 941
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/efile-irs-form-941-x-online/">
                  Form 941-X
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/e-file-irs-form-941-sp/">
                  Form 941-SP
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/e-file-irs-form-941-schedule-r/">
                  Form 941 Schedule R
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/e-file-irs-form-940/">
                  Form 940
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/efile-irs-form-940-amendment/">
                  Form 940 Amendment
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/e-file-irs-form-943/">
                  Form 943
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/e-file-irs-form-943-x/">
                  Form 943-X
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/e-file-irs-form-944/">
                  Form 944
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/e-file-irs-form-945/">
                  Form 945
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/e-file-irs-form-945-x/">
                  Form 945-X
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/e-file-irs-form-94x-pin-request/">
                  Form 94x PIN <span style={{ fontWeight: 700 }}>(FREE)</span>
                </Link>
              </li>
            </Box>
          </Box>
        </Box>
        <Box
          className={getSubMenuHoverClassName('btn-employment-supported-forms')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-employment-supported-forms"
            onClick={() =>
              toggleSelectedSubMenu('btn-employment-supported-forms')
            }
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
            className={getActiveClassName([
              '/employment-tax/state-payroll-tax/alabama-filing-requirements',
              '/employment-tax/state-payroll-tax/arizona-filing-requirements',
              '/employment-tax/state-payroll-tax/arkansas-filing-requirements',
              '/employment-tax/state-payroll-tax/california-filing-requirements',
              '/employment-tax/state-payroll-tax/colorado-filing-requirements',
              '/employment-tax/state-payroll-tax/connecticut-filing-requirements',
              '/employment-tax/state-payroll-tax/delaware-filing-requirements',
              '/employment-tax/state-payroll-tax/georgia-filing-requirements',
              '/employment-tax/state-payroll-tax/hawaii-filing-requirements',
              '/employment-tax/state-payroll-tax/idaho-filing-requirements',
              '/employment-tax/state-payroll-tax/illinois-filing-requirements',
              '/employment-tax/state-payroll-tax/indiana-filing-requirements',
              '/employment-tax/state-payroll-tax/iowa-filing-requirements',
              '/employment-tax/state-payroll-tax/kansas-filing-requirements',
            ])}
          >
            State Requirements
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{ width: 200, '&:before': { left: 50 } }}
          >
            <Box component="ul">
              <li>
                <Link href="/employment-tax/state-payroll-tax/alabama-filing-requirements/">
                  Alabama (AL)
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/state-payroll-tax/arizona-filing-requirements/">
                  Arizona (AZ)
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/state-payroll-tax/arkansas-filing-requirements/">
                  Arkansas (AR)
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/state-payroll-tax/california-filing-requirements/">
                  California (CA)
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/state-payroll-tax/colorado-filing-requirements/">
                  Colorado (CO)
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/state-payroll-tax/connecticut-filing-requirements/">
                  Connecticut (CT)
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/state-payroll-tax/delaware-filing-requirements/">
                  Delaware (DE)
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/state-payroll-tax/georgia-filing-requirements/">
                  Georgia (GA)
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/state-payroll-tax/hawaii-filing-requirements/">
                  Hawaii (HI)
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/state-payroll-tax/idaho-filing-requirements/">
                  Idaho (ID)
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/state-payroll-tax/illinois-filing-requirements/">
                  Illinois (IL)
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/state-payroll-tax/indiana-filing-requirements/">
                  Indiana (IN)
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/state-payroll-tax/iowa-filing-requirements/">
                  Iowa (IA)
                </Link>
              </li>
              <li>
                <Link href="/employment-tax/state-payroll-tax/kansas-filing-requirements/">
                  Kansas (KS)
                </Link>
              </li>
            </Box>
          </Box>
        </Box>
        <Box
          className={getSubMenuHoverClassName('btn-employment-resources')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-employment-resources"
            onClick={() => toggleSelectedSubMenu('btn-employment-resources')}
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
          >
            Resources
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: 220,

              '&:before': { left: 50 },
            }}
          >
            <Box component="ul">
              <li>
                <Link href="/resources/employment-tax/form-941-filing-deadlines-and-penalties-guide/">
                  Form 941 Due dates
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-941-mailing-address/">
                  Form 941 Mailing Address
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-941-bulk-upload/">
                  Form 941 Bulk Upload
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-941-schedule-b-filing-requirements/">
                  Form 941 Schedule B
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-941-schedule-r/">
                  Form 941 Schedule R
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-941-vs-form-944/">
                  Form 941 Vs Form 944
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/irs-form-940-due-dates/">
                  Form 940 Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-940-mailing-address/">
                  Form 940 Mailing Address
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-943-due-dates/">
                  Form 943 Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-944-due-dates/">
                  Form 944 Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-945-due-dates/">
                  Form 945 Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-941-x-due-dates/">
                  Form 941-X Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-940-schedule-a/">
                  Form 940 Schedule A
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-940-vs-form-941/">
                  Form 940 VS Form 941
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-941-944-deposit-requirements/">
                  Payroll Tax Deposits
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/irs-form-941-2024-updates/">
                  Revised Form 941 2024
                </Link>
              </li>

              <li>
                <Link href="/resources/employment-tax/form-941-penalties/">
                  Form 941 Penalties
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/futa-tax/">FUTA</Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/fica-tax/">FICA Tax</Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/employer-payroll-taxes/">
                  Employer Payroll Taxes
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/employers-quarterly-federal-tax-return/">
                  Quarterly Federal Tax Return
                </Link>
              </li>
            </Box>
          </Box>
        </Box>
        <Box
          className={getSubMenuHoverClassName('btn-employment-instructions')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-employment-instructions"
            onClick={() => toggleSelectedSubMenu('btn-employment-instructions')}
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
          >
            Instructions
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: 220,
              left: 'auto !important',
              right: 0,
              '&:before': { right: 50 },
            }}
          >
            <Box component="ul">
              <li>
                <Link href="/resources/employment-tax/form-941-instructions/">
                  Form 941 Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-941-instructions-2023/">
                  Form 941 Instructions 2023
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-941-signature-options/">
                  Form 941 Signature Options
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-940-instructions/">
                  Form 940 Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-941-x-instructions/">
                  Form 941-X Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-943-instructions/">
                  Form 943 Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-944-instructions/">
                  Form 944 Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-945-instructions/">
                  Form 945 Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/employment-tax/form-945-x-instructions/">
                  Form 945-X Instructions
                </Link>
              </li>

              <li>
                <Link href="/resources/employment-tax/form-8974-instructions/">
                  Form 8974 Instructions
                </Link>
              </li>
            </Box>
          </Box>
        </Box>
        <CustomButton
          href="/pricing/#employment"
          text="Pricing"
          sm="12px"
          md="14px"
        />
      </Container>
    </Box>
  );
};

export default EmploymentSubMenu;
